<aside class="bg-primary h-full flex flex-col transition-all duration-300 select-none"
       [class.w-sidebar]="!collapsed" [class.w-sidebar-collapsed]="collapsed">
  <div class="flex items-center gap-3 px-6 h-16 border-b border-white/10 shrink-0">
    <div class="w-8 h-8 bg-white rounded-lg flex items-center justify-center shrink-0">
      <span class="text-primary font-black text-sm">DH</span>
    </div>
    <span *ngIf="!collapsed" class="text-white font-bold text-lg whitespace-nowrap">DigiHR</span>
  </div>

  <nav class="flex-1 overflow-y-auto px-3 py-4 space-y-1">
    <ng-container *ngFor="let item of menuItems">
      <div *ngIf="!item.children; else hasChildren">
        <a [routerLink]="item.route"
           routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: true}"
           class="sidebar-item"
           [class.justify-center]="collapsed"
           [title]="collapsed ? item.label : ''">
          <lucide-icon [name]="item.icon" [size]="20"></lucide-icon>
          <span *ngIf="!collapsed" class="text-sm font-medium">{{ item.label }}</span>
        </a>
      </div>
      <ng-template #hasChildren>
        <div>
          <div (click)="toggleSubmenu(item)"
               class="sidebar-item"
               [class.justify-center]="collapsed"
               [title]="collapsed ? item.label : ''">
            <lucide-icon [name]="item.icon" [size]="20"></lucide-icon>
            <span *ngIf="!collapsed" class="flex-1 text-sm font-medium">{{ item.label }}</span>
            <lucide-icon *ngIf="!collapsed" [name]="'ChevronDown'" [size]="16"
                        class="transition-transform duration-200"
                        [class.rotate-180]="item.expanded"></lucide-icon>
          </div>
          <div *ngIf="item.expanded && !collapsed" class="ml-6 mt-1 space-y-1 border-l border-white/10 pl-3">
            <a *ngFor="let child of item.children"
               [routerLink]="child.route"
               routerLinkActive="active"
               class="sidebar-submenu-item">
              <lucide-icon [name]="child.icon" [size]="16"></lucide-icon>
              <span class="text-sm">{{ child.label }}</span>
            </a>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </nav>

  <div class="px-3 py-4 border-t border-white/10 shrink-0">
    <button (click)="toggleCollapse()"
            class="sidebar-item w-full"
            [class.justify-center]="collapsed"
            [title]="collapsed ? 'Expand' : 'Collapse'">
      <lucide-icon [name]="'ChevronLeft'" [size]="20"
                  class="transition-transform duration-200"
                  [class.rotate-180]="collapsed"></lucide-icon>
      <span *ngIf="!collapsed" class="text-sm font-medium">Collapse</span>
    </button>
  </div>
</aside>
